import * as React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

type ConcentricRingLogoProps = {
  variant: "shopify" | "replo";
  isSelected?: boolean;
  hoverDirection?: "left" | "right";
  className?: string;
};

export const ConcentricRingLogo: React.FC<ConcentricRingLogoProps> = ({
  variant,
  isSelected = false,
  hoverDirection,
  className,
}) => {
  return (
    <div
      style={{
        backgroundImage: `url(/images/onboarding/${variant}-circle${isSelected ? "-color" : ""}.svg)`,
      }}
      className={twMerge(
        "bg-no-repeat bg-contain bg-center transition-all duration-300",
        hoverDirection === "right" && "group-hover:translate-x-2",
        hoverDirection === "left" && "group-hover:-translate-x-2",
        className,
      )}
      aria-label={variant === "shopify" ? "Shopify" : "Replo"}
    />
  );
};
